/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_PreferredInputs */

const cs_pipelines_preferred = /** @type {(inputs: Pipelines_PreferredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moje preferovaná task pipeline`)
};

const en_pipelines_preferred = /** @type {(inputs: Pipelines_PreferredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My preferred task pipeline`)
};

/**
* | output |
* | --- |
* | "My preferred task pipeline" |
*
* @param {Pipelines_PreferredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_preferred = /** @type {((inputs?: Pipelines_PreferredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_PreferredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_preferred(inputs)
	return cs_pipelines_preferred(inputs)
});